import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import Loading from "react-fullscreen-loading";
import {
  MdOutlineSettings,
  MdAutorenew,
  MdArrowBackIos,
  MdCameraAlt,
  MdArrowForwardIos,
  MdCalendarToday,
  MdLocationOn,
  MdPeopleAlt,
} from "react-icons/md";
import { toast } from "react-toastify";
import httpService from "services/http-service";
import { getLocalStorageValue } from "utils/utils";
import { getLocalStorageKey } from "utils/utils";
import Header from "components/header/HeaderAuthDefault";
import { IoMdHeartEmpty } from "react-icons/io";
import { MdOutlineClose, MdOutlineQrCodeScanner } from 'react-icons/md';
import user from "assets/img/icons/user.png";
import 'sweetalert2/dist/sweetalert2.min.css'; // Optional: for default Swal styling
import Sheet from 'react-modal-sheet';
import UserProfile from "./UserProfile";
import { Button, Dialog, DialogContent, DialogTitle, Drawer, IconButton, Skeleton, useMediaQuery } from "@mui/material";
import EventScan from "./Eventscan";
import Gallery from "./Gallery";
import { FaArrowLeft, FaCross, FaTimes, FaLinkedin } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
// import { Drawer } from "@chakra-ui/modal";
import logo from "assets/img/logo/logo.png";
import AttendeesDrawer from "./AtendeesDrawer";

export default function Event({ ...props }) {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
const [isAttendeesDrawerOpen, setAttendeesDrawerOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [sponsors, setSponsors] = useState([]);
  const [hosts, setHosts] = useState([]);
  const [vipUsers, setVipUsers] = useState([]);
  const [recommendedUsers, setRecommendedUsers] = useState([]);
  const [waveClicked, setWaveClicked] = useState(false);
  const [otherUsers, setOtherUsers] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [eventName, seteventName] = useState('');
  const [showNotifications, setShowNotifications] = useState(false);
  const [showReactions, setShowReactions] = useState(false);
  const [reactionClicked, setReactionClicked] = useState(false);
  const dropdownRef = useRef(null);
  const [selectedUserId, setSelectedUserId] = useState(0);
  const [showEventScan, setShowEventScan] = useState(false);
  const eventId = getLocalStorageKey("eventId");
  const userId = getLocalStorageValue("userDetails", "userId");
  const [hasNotifications, setHasNotifications] = useState(false);
  const [matches, setMatches] = React.useState([]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [chats, setChats] = React.useState([]);
  // Event photos state
  const [photos, setPhotos] = useState([]);
  // Event meta (date / location / attendee count) shown under the title
  const [eventDate, setEventDate] = useState('');
  const [eventLocation, setEventLocation] = useState('');
  const [attendeeCount, setAttendeeCount] = useState(0);
  // Toggles the Attendees card between a short preview row and the full list
  const [showAllAttendees, setShowAllAttendees] = useState(false);

  const openConfirmation = (message, callback) => {
    setConfirmationMessage(message);
    setShowConfirmation(true);
  };

  // Function to close confirmation popup
  const closeConfirmation = () => {
    setShowConfirmation(false);
  };

  // Function to handle confirmation action
  const handleConfirmation = () => {
    // Handle confirmation action
    // For example: callback();
    // Then close the confirmation popup
    closeConfirmation();
  };


  const handleQRCodeIconClick = () => {
    setShowEventScan(true);
  };

  const handleCloseEventScan = () => {
    setShowEventScan(false);
  };

  const handleClick = () => {
    if (!reactionClicked) {
      setShowReactions(true);
    }
  };
  const handleReactionClick = () => {
    setShowReactions(false);
    setReactionClicked(true);
  };
  const handleWaveIconClick = () => {
    if (!reactionClicked) {
      setShowReactions(false);
      setReactionClicked(false);
    }
  };
  const handleEventPhotosClick = () => {
    // navigate('/auth/welcome')
    // window.open('/auth/welcome', '_blank');
    setDrawerOpen(true);

  };

  // Inside the useEffect hook that fetches data
 useEffect(() => {
  getAlEvents();
}, []);

  // Inside the populateData function
  const populateData = async () => {
    setLoading(true);
    const userId = getLocalStorageValue("userDetails", "userId");

    const endpoint = `EventUserInteraction/GetMatchQueue?UserId=${userId}`;
    const response = await httpService("GET", endpoint);

    if (!response) {
      setLoading(false);
      toast.error('Something went wrong');
    } else {
      setLoading(false);
      setMatches(response?.matches || []);
      setChats(response?.chats || []);

      // Calculate hasNotifications based on whether there are matches or chats
      const hasNotifications = response.matches.length > 0 || response.chats.length > 0;

      // Update the local state
      setHasNotifications(hasNotifications);
    }
  };

  const handleWaveClick = () => {
    setWaveClicked(true);
    toast.success("We'll let them know you've waved.");
  };

  const toggleNotifications = () => {
    setShowNotifications(!showNotifications);
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {

    // Cleanup function

    // Add event listener to handle outside click
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false); // Close the dropdown if clicked outside of it
    }
  };

  const selectUserProfile = (eventData) => {
    const instagram = eventData?.user?.instagram || eventData?.instagram;
    const linkedIn = eventData?.user?.linkedInUrl || eventData?.user?.linkedIn || eventData?.linkedInUrl || eventData?.linkedIn;

    if (instagram) {
      const url = instagram.startsWith("http") ? instagram : `https://instagram.com/${instagram}`;
      window.open(url, "_blank");
      return;
    }

    if (linkedIn) {
      const url = linkedIn.startsWith("http") ? linkedIn : `https://${linkedIn}`;
      window.open(url, "_blank");
      return;
    }
  };

  const selectRecommendedUserProfile = (recommended) => {
    const instagram = recommended?.user?.instagram || recommended?.instagram;
    const linkedIn = recommended?.user?.linkedInUrl || recommended?.user?.linkedIn || recommended?.linkedInUrl || recommended?.linkedIn;

    if (instagram) {
      const url = instagram.startsWith("http") ? instagram : `https://instagram.com/${instagram}`;
      window.open(url, "_blank");
      return;
    }

    if (linkedIn) {
      const url = linkedIn.startsWith("http") ? linkedIn : `https://${linkedIn}`;
      window.open(url, "_blank");
      return;
    }
  };

  const closeUserProfile = () => {
    setSelectedUser(null);
    setIsOpen(false); // Close the sheet when user profile is closed
  };

  const handleLinkClick = (url) => {
    if (!url) return;
    window.open(url, "_blank");
  };

 const handleOptionClick = async (option) => {
  if (option === "refresh") {
    getAlEvents();
  } else if (option === "settings" || option === "edit-profile") {
    navigate('/auth/edit-profile', { state: { fromEventsPage: true } });
  } else if (option === "logout") {
    localStorage.clear();
    navigate('/auth/sign-in');
  } else if (option === "savedProfiles") {
    navigate('/auth/saved-profiles');
  } else {
    navigate(option);
  }
};

  useEffect(() => {
    getAlEvents();
  }, []);

  const collectImageUrls = (eventData) => {
    const urls = [];
    eventData?.hosts?.forEach((h) => {
      if (h?.user?.photoUrl) urls.push(h.user.photoUrl);
    });
    eventData?.sponsors?.forEach((s) => {
      if (s?.photo) urls.push(s.photo);
    });
    eventData?.vipUsers?.forEach((v) => {
      if (v?.user?.photoUrl) urls.push(v.user.photoUrl);
    });
    eventData?.recommendedUsers?.forEach((r) => {
      if (r?.user?.photoUrl) urls.push(r.user.photoUrl);
    });
    eventData?.otherUsers?.forEach((o) => {
      if (o?.user?.photoUrl) urls.push(o.user.photoUrl);
    });
    return urls;
  };

  const preloadImages = (urls) => {
    return Promise.all(
      urls.map((url) => {
        return new Promise((resolve) => {
          if (!url) return resolve();
          const img = new Image();
          img.src = url;
          img.onload = () => resolve();
          img.onerror = () => resolve();
        });
      })
    );
  };



    const extractImageUrl = (item) => {
    if (!item) return null;
    if (typeof item === "string") return item;
    return item.content || item.mediaUrl || item.url || item.photoUrl || item.filePath || null;
  };

  // Normalizes whatever shape the photos endpoint (or a cached payload) returns into a flat array of image items
  const extractPhotosList = (source) => {
    let rawList = [];
    if (Array.isArray(source)) {
      rawList = source;
    } else if (source?.data && Array.isArray(source.data)) {
      rawList = source.data;
    } else if (source?.photos && Array.isArray(source.photos)) {
      rawList = source.photos;
    }

    return rawList.filter((item) => {
      if (!item) return false;
      if (typeof item === "string") return true;
      const isImage = !item.type || item.type.toLowerCase() === "image";
      return isImage && Boolean(extractImageUrl(item));
    });
  };

  // "Sep 20, 2026" style formatting for whatever date string the API sends back
  const formatEventDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  // Two-letter initials fallback for attendees/hosts without a photo (e.g. "JD")
  const getInitials = (firstName, lastName) => {
    const a = (firstName || '').trim();
    const b = (lastName || '').trim();
    if (a && b) return `${a[0]}${b[0]}`.toUpperCase();
    if (a) return a.slice(0, 2).toUpperCase();
    return '?';
  };

  // Renders either the photo or an initials circle, filling the parent avatar wrapper
  const renderAvatarInner = (photoUrl, firstName, lastName) => {
    if (photoUrl) {
      return (
        <img
          className="h-full w-full object-cover"
          src={photoUrl}
          alt={firstName || 'attendee'}
          onError={handleImageError}
        />
      );
    }
    return (
      <div className="h-full w-full flex items-center justify-center bg-gray-100 text-gray-500 font-semibold text-sm">
        {getInitials(firstName, lastName)}
      </div>
    );
  };

const getAlEvents = async () => {
  setLoading(true);

  if (!eventId) {
    navigate('/auth/home');
    return;
  }

  const peopleEndpoint = `/Event/GetEventPeople/${eventId}`;
  const photosEndpoint = `/EventContent/GetByEvent/${eventId}`;

  try {
    const storedEventId = sessionStorage.getItem('currentEventId');
    if (storedEventId && storedEventId !== eventId) {
      sessionStorage.removeItem(`eventData_${storedEventId}`);
    }

    sessionStorage.setItem('currentEventId', eventId);

    const cachedData = sessionStorage.getItem(`eventData_${eventId}`);
    
    if (cachedData) {
      const parsed = JSON.parse(cachedData);
      await preloadImages(collectImageUrls(parsed));
      updateEventData(parsed);
      setPhotos(extractPhotosList(parsed));
      setLoading(false);
      setShowDropdown(false);
      return;
    }

    const [response, photosRes] = await Promise.all([
      httpService("GET", peopleEndpoint),
      httpService("GET", photosEndpoint).catch(() => null),
    ]);
    
    if (response.Error === "HttpException") {
      toast.error(response.Message);
    } else {
      const photosList = extractPhotosList(photosRes);
      const combined = { ...response, photos: photosList };
      sessionStorage.setItem(`eventData_${eventId}`, JSON.stringify(combined));
      await preloadImages(collectImageUrls(response));
      updateEventData(response);
      setPhotos(photosList);
    }

    setLoading(false);
    setShowDropdown(false);
  } catch (error) {
    setLoading(false);
    toast.error("Failed to fetch event data");
  }
};

  const updateEventData = (eventData) => {
    seteventName(eventData?.eventName);
    setSponsors(eventData?.sponsors || []);
    setHosts(eventData?.hosts || []);
    setVipUsers(eventData?.vipUsers || []);
    setOtherUsers(eventData?.otherUsers || []);
    setRecommendedUsers(eventData?.recommendedUsers || []);

    // Best-effort meta fields — adjust the source keys here if your API names them differently
    setEventDate(eventData?.eventDate || eventData?.date || eventData?.startDate || '');
    setEventLocation(eventData?.location || eventData?.venue || eventData?.city || '');
    setAttendeeCount(
      eventData?.attendeeCount ??
      ((eventData?.hosts?.length || 0) +
        (eventData?.vipUsers?.length || 0) +
        (eventData?.recommendedUsers?.length || 0) +
        (eventData?.otherUsers?.length || 0))
    );
  };



  // const selectUserProfile = (eventData) => {
  //   console.log(eventData);
  //   localStorage.setItem('selectedUserId', eventData?.userId);
  //   navigate('/auth/user-profile')
  // };
  const isMobile = useMediaQuery('(max-width: 768px)');

  const drawerWidth = isMobile ? '100%' : '50%';

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = user;
  };

  const hasPhotos = Array.isArray(photos) && photos.length > 0;

  // Attendees card combines recommended + other users into one list, matching the design
  const allAttendees = [...recommendedUsers, ...otherUsers];
  const totalAttendees = allAttendees.length;
  const attendeesPreviewLimit = 8;
  const visibleAttendees = showAllAttendees ? allAttendees : allAttendees.slice(0, attendeesPreviewLimit);

  return (
    <>
      <div className="fixed top-0 left-0 w-full z-50 bg-white">
        <div className="flex relative mt-3  mb-2 ">
          <Header className="sticky top-0 bg-white shadow-md border-b border-gray-200" />
          {/* <div className="mt-2 mr-2 text-2xl transition duration-300 hover:text-gray-500 cursor-pointer" onClick={() => handleOptionClick("/auth/notifications")}>
            {hasNotifications && <div className="absolute top-2 right-16 mr-1 h-3 w-3 bg-red-500 rounded-full"></div>}
            <IoMdHeartEmpty />
          </div> */}

          {/* Add QR code icon */}
          {/* <div className="mt-2 mr-2 text-2xl transition duration-300 hover:text-gray-500 cursor-pointer">
            <MdOutlineQrCodeScanner onClick={handleQRCodeIconClick} />
          </div> */}
          {/* Dialog for EventScan */}
          <Dialog open={showEventScan} onClose={handleCloseEventScan} maxWidth="sm" fullWidth>
            <div className="p-4">
              <IconButton
                onClick={handleCloseEventScan}
                style={{ position: 'absolute', right: 8, top: 8 }}
              >
                <MdOutlineClose />
              </IconButton>
              <EventScan onClose={handleCloseEventScan} />
            </div>
          </Dialog>
          {/* Full Page Popup for Notifications */}
          {/* {showNotifications && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white p-8 h-full w-full max-h-screen overflow-y-auto">
                <button className="absolute top-0 right-0 p-2" onClick={toggleNotifications}>
                  <MdOutlineClose className="h-6 w-6" />
                </button>
                <Notifications setHasNotifications={setHasNotifications} />
              </div>
            </div>
          )} */}
          <div
            className="mt-2 mr-4 text-2xl transition duration-300 hover:text-gray-500 cursor-pointer"
            onClick={toggleDropdown}
          >
            <MdOutlineSettings />
          </div>

          {showDropdown && (
            <div ref={dropdownRef} className="absolute right-0 mt-10 w-48 bg-white rounded-md shadow-lg z-50">
              <div className="py-1">
                <button
                  onClick={getAlEvents}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-800 hover:bg-gray-200"
                >
                  Refresh
                </button>

                {/* Commenting out for MVP
      <button
        onClick={() => handleOptionClick("settings")}
        className="block w-full text-left px-4 py-2 text-sm text-gray-800 hover:bg-gray-200"
      >
        Edit profile
      </button>
      */}

                {/* <button
                  onClick={() => handleOptionClick("/auth/myevents")}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-800 hover:bg-gray-200"
                >
                  My events
                </button> */}

                {/* <button
                  onClick={() => handleOptionClick("savedProfiles")}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-800 hover:bg-gray-200"
                >
                  Saved Profiles
                </button> */}
                {/* <button
                 onClick={() => handleOptionClick("/auth/edit-profile")}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-800 hover:bg-gray-200"
                >
                  Edit Profile
                </button> */}
                <button
                  onClick={() => handleOptionClick("logout")}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-800 hover:bg-gray-200"
                >
                  Logout
                </button>
              </div>
            </div>
          )}

          {/*Floating Action Button*/} {/*<div className="fixed bottom-8 right-4">
            
            <button className="bg-brand-500 hover:bg-brand-700 text-white py-2 px-4 rounded-full shadow-md">
              +
            </button>    </div>

       */}
        </div>
        {/* Separation line */}
        <div className="border-t border-gray-200"></div>
      </div>

      <div className="flex overflow-y-auto hide-scrollbar h-full w-full justify-center md:mx-0 md:px-0 lg:mb-10 lg:justify-start">
        {loading ? (
          <div className="mt-14 w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
            <Skeleton variant="text" width="60%" height={40} className="mb-5 mt-5" />

            <div className="mb-4 rounded-2xl border border-gray-100 bg-white p-4">
              <Skeleton variant="text" width="30%" height={26} className="mb-3" />
              <div className="flex gap-6">
                {[1, 2, 3].map((item) => (
                  <div key={item}>
                    <Skeleton variant="circular" width={64} height={64} />
                    <Skeleton variant="text" width={64} className="mt-1" />
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-4 rounded-2xl border border-gray-100 bg-white p-4">
              <Skeleton variant="text" width="30%" height={26} className="mb-3" />
              <div className="flex gap-6">
                {[1, 2].map((item) => (
                  <div key={item}>
                    <Skeleton variant="circular" width={64} height={64} />
                    <Skeleton variant="text" width={64} className="mt-1" />
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-4 rounded-2xl border border-gray-100 bg-white p-4">
              <Skeleton variant="text" width="40%" height={26} className="mb-3" />
              <div className="flex flex-wrap gap-4">
                {[1, 2, 3, 4, 5].map((item) => (
                  <div key={item} className="flex flex-col items-center">
                    <Skeleton variant="circular" width={64} height={64} />
                    <Skeleton variant="text" width={48} height={18} className="mt-1" />
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-4 rounded-2xl border border-gray-100 bg-white p-4">
              <Skeleton variant="text" width="40%" height={26} className="mb-3" />
              <div className="grid grid-cols-4 gap-1">
                {[1, 2, 3, 4].map((item) => (
                  <Skeleton key={item} variant="rectangular" className="aspect-square rounded-lg" />
                ))}
              </div>
            </div>
          </div>
        ) : (
        <div className="mt-14 w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">

          {/* Title + meta */}
          <div className="mb-4">
            <h4 className="py-2  text-left text-2xl font-bold leading-snug text-navy-700">
              {eventName}
            </h4>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-gray-500">
              {eventDate && (
                <span className="flex items-center gap-1">
                  <MdCalendarToday className="h-3.5 w-3.5" />
                  {formatEventDate(eventDate)}
                </span>
              )}
              { (
                <span className="flex items-center gap-1">
                  <MdLocationOn className="h-3.5 w-3.5" />
                  {eventLocation || 'Atlant, GA'}
                </span>
              )}
              {attendeeCount > 0 && (
                <span className="flex items-center gap-1">
                  <MdPeopleAlt className="h-3.5 w-3.5" />
                  {attendeeCount} attendees
                </span>
              )}
            </div>
          </div>

             {/* Hosts */}
          <div className="mb-4 rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
            {/* <h6 className="mb-3 text-sm font-semibold text-event-footer">Hosts</h6> */}
            {hosts && hosts.length > 0 ? (
              <div className="flex items-start gap-6 overflow-x-auto hide-scrollbar">
                {hosts.map((host) => (
                  <div
                    className="flex flex-shrink-0 flex-col items-center text-center"
                    onClick={() => selectUserProfile(host)}
                    key={host.id}
                  >
                    <div className="h-16 w-16 overflow-hidden rounded-full border-2 border-black">
                      {renderAvatarInner(host.user?.photoUrl, host?.user?.firstName, host?.user?.lastName)}
                    </div>
                    <h6 className="mt-1.5 text-sm font-semibold text-navy-700">
                      {host?.user?.firstName?.split(' ')[0] || 'Anonymous'}
                    </h6>
                 <p className="text-xs text-gray-500">
                      {host.hostRole}
                      {/* {host?.makeFriends && ' 🎉'}
                      {host?.network && ' 🤝'}
                      {host?.date && ' ❤️'} */}
                    </p>
                    {(host?.user?.linkedInUrl || host?.linkedInUrl) && (
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleLinkClick(host?.user?.linkedInUrl || host?.linkedInUrl);
                        }}
                        aria-label="LinkedIn profile"
                        className="mt-1.5 flex h-5 w-5 items-center justify-center rounded bg-[#0B132B] text-white"
                      >
                        <FaLinkedin className="h-3 w-3" />
                      </button>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-sm text-gray-500 text-center">No hosts, see host to become one.</p>
            )}
          </div>

          {/* Sponsors */}
         {sponsors && sponsors.length > 0 &&  <div className="mb-4 rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
            <h6 className="mb-3 text-sm font-semibold text-event-footer">Partners</h6>
            {sponsors && sponsors.length > 0 ? (
              <div className="flex items-start gap-6 overflow-x-auto hide-scrollbar">
                {sponsors.map((sponsor) => (
                  <div
                    key={sponsor.id}
                    onClick={() => handleLinkClick(sponsor.url)}
                    className="flex flex-shrink-0 flex-col items-center text-center"
                  >
                    <div className="h-16 w-16 overflow-hidden rounded-full border-2 border-black bg-white">
                      <img
                        className="h-full w-full object-contain"
                        src={sponsor?.photo || user}
                        alt="logo"
                        onError={handleImageError}
                      />
                    </div>
                    <h6 className="mt-1.5 text-sm font-semibold text-navy-700">
                      {sponsor.displayName}
                    </h6>
                    <p className="text-xs text-gray-500">{sponsor?.sponsorsRole}</p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-sm text-gray-500 text-center">No sponsors, see host to become one.</p>
            )}
          </div>}

          {/* VIPs */}
{     vipUsers && vipUsers?.length > 0  &&     <div className="mb-4 rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
            <h6 className="mb-3 text-sm font-semibold text-event-footer">VIPs</h6>
            {vipUsers && vipUsers?.length > 0 ? (
              <div className="flex items-start gap-6 overflow-x-auto hide-scrollbar">
                {vipUsers.map((vip) => (
                  <div
                    className="flex flex-shrink-0 flex-col items-center text-center"
                    onClick={() => selectUserProfile(vip)}
                    key={vip.id}
                  >
                    <div className="h-16 w-16 overflow-hidden rounded-full border-2 border-black">
                      {renderAvatarInner(vip.user?.photoUrl, vip?.user?.firstName, vip?.user?.lastName)}
                    </div>
                    <h6 className="mt-1.5 text-sm font-semibold text-navy-700">
                      {vip?.user?.firstName?.split(' ')[0]}
                    </h6>
                    <p className="text-xs text-gray-500">
                      {vip?.makeFriends && '🎉'}
                      {vip?.network && '🤝'}
                      {vip?.date && '❤️'}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-sm text-gray-500 text-center">No VIPs, see host to become one.</p>
            )}
          </div>}

          {/* Attendees (recommended + other, combined to match design) */}
          <div className="mb-4 rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
            <div className="mb-3 flex items-center justify-between">
              <h6 className="text-sm font-semibold text-event-footer">
                Attendees
                {/* {totalAttendees > 0 && <span className="text-gray-400"> · {totalAttendees}</span>} */}
              </h6>
              {/* {totalAttendees > attendeesPreviewLimit && (
                <button
                  type="button"
                  onClick={() => setShowAllAttendees((v) => !v)}
                  className="flex items-center gap-0.5 text-sm font-medium text-blue-600 hover:text-blue-700"
                >
                  {showAllAttendees ? 'Show less' : 'View all'}
                  <MdArrowForwardIos className="h-3 w-3" />
                </button>
              )} */}
              {totalAttendees > attendeesPreviewLimit && (
  <button
    type="button"
    onClick={() => setAttendeesDrawerOpen(true)}
    className="flex items-center gap-0.5 text-sm font-medium text-blue-600 hover:text-blue-700"
  >
    View all
    <MdArrowForwardIos className="h-3 w-3" />
  </button>
)}

<AttendeesDrawer
  open={isAttendeesDrawerOpen}
  onClose={() => setAttendeesDrawerOpen(false)}
  attendees={allAttendees}
  onSelectAttendee={(attendeeItem) => {
    // reuse existing select logic: recommended vs other
    const isRecommended = recommendedUsers.some(
      (r) => r.id === attendeeItem.id
    );
    setAttendeesDrawerOpen(false);
    if (isRecommended) {
      selectRecommendedUserProfile(attendeeItem);
    } else {
      selectUserProfile(attendeeItem);
    }
  }}
  title="Guests"
/>
            </div>

          {totalAttendees > 0 ? (
  totalAttendees >= 6 ? (
    // 6+ attendees: 2-row grid (wraps naturally into rows)
    <div className="grid grid-cols-4 gap-x-4 gap-y-4">
      {visibleAttendees.map((attendeeItem, idx) => {
        const isRecommended =
          idx < recommendedUsers.length &&
          attendeeItem === recommendedUsers[idx];
        const onSelect = () =>
          isRecommended
            ? selectRecommendedUserProfile(attendeeItem)
            : selectUserProfile(attendeeItem);
        return (
          <div
            key={attendeeItem.id}
            className="flex flex-col items-center text-center"
            onClick={onSelect}
          >
            <div className="h-16 w-16 overflow-hidden rounded-full border-2 border-black">
              {renderAvatarInner(
                attendeeItem.user?.photoUrl,
                attendeeItem?.user?.firstName,
                attendeeItem?.user?.lastName
              )}
            </div>
            <h6 className="mt-1.5 text-sm font-semibold text-navy-700">
              {attendeeItem?.user?.firstName?.split(' ')[0] || 'Anonymous'}
            </h6>
          </div>
        );
      })}
    </div>
  ) : (
    // < 6 attendees: single row horizontal scroll (original behavior)
    <div className="flex items-start gap-4 overflow-x-auto hide-scrollbar">
      {visibleAttendees.map((attendeeItem, idx) => {
        const isRecommended =
          idx < recommendedUsers.length &&
          attendeeItem === recommendedUsers[idx];
        const onSelect = () =>
          isRecommended
            ? selectRecommendedUserProfile(attendeeItem)
            : selectUserProfile(attendeeItem);
        return (
          <div
            key={attendeeItem.id}
            className="flex flex-shrink-0 flex-col items-center text-center"
            onClick={onSelect}
          >
            <div className="h-16 w-16 overflow-hidden rounded-full border-2 border-black">
              {renderAvatarInner(
                attendeeItem.user?.photoUrl,
                attendeeItem?.user?.firstName,
                attendeeItem?.user?.lastName
              )}
            </div>
            <h6 className="mt-1.5 text-sm font-semibold text-navy-700">
              {attendeeItem?.user?.firstName?.split(' ')[0] || 'Anonymous'}
            </h6>
          </div>
        );
      })}
    </div>
  )
) : (
  <div onClick={handleQRCodeIconClick} className="cursor-pointer">
    <p className="text-sm text-gray-500 text-center">
      Tap here and share with others in the venue.
    </p>
  </div>
)}
          </div>

          {/* Event Photos */}
          <div className="mb-8 rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-2">
                {hasPhotos && (
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#0B132B] text-white">
                    <MdCameraAlt className="h-3.5 w-3.5" />
                  </span>
                )}
                <div>
                  <h6 className="text-sm font-semibold text-event-footer leading-tight">Event Photos</h6>
                  {hasPhotos && (
                    <p className="text-xs text-[#6B7280]">{photos.length} photos</p>
                  )}
                </div>
              </div>

              {hasPhotos && (
                <button
                  type="button"
                  onClick={handleEventPhotosClick}
                  className="flex items-center gap-0.5 text-sm font-medium text-blue-600 hover:text-blue-700"
                >
                  View all
                  <MdArrowForwardIos className="h-3 w-3" />
                </button>
              )}
            </div>

            {hasPhotos ? (
              <div className="grid grid-cols-4 gap-1 cursor-pointer" onClick={handleEventPhotosClick}>
                {photos.slice(0, 3).map((item, i) => {
                  const imgUrl = extractImageUrl(item);
                  return (
                    <div key={i} className="aspect-square rounded-lg overflow-hidden bg-[#F1F5F9]">
                      <img
                        src={imgUrl}
                        className="w-full h-full object-cover"
                        alt={`Event photo ${i + 1}`}
                      />
                    </div>
                  );
                })}
                {photos.length > 3 && (
                  <div className="relative aspect-square rounded-lg overflow-hidden bg-[#0B132B]">
                    <img
                      src={extractImageUrl(photos[3])}
                      className="w-full h-full object-cover"
                      alt=""
                    />
                    {/* dark overlay keeps the +N label readable on any photo */}
                    <div className="absolute inset-0 flex items-center justify-center bg-[rgba(11,19,43,0.65)]">
                      <span className="text-white font-bold text-sm tracking-tight">
                        +{photos.length - 3}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="py-6 px-4 flex flex-col items-center justify-center text-center">
                <div className="w-12 h-12 rounded-full bg-[#F1F5F9] text-[#9CA3AF] flex items-center justify-center mb-3">
                  <MdCameraAlt className="w-6 h-6" />
                </div>
                <h4 className="text-sm font-semibold text-navy-700 mb-1">
                  No photos have been added yet.
                </h4>
                <p className="text-[12px] text-[#6B7280] max-w-[260px] leading-relaxed">
                  Check back after the event to see photos from this experience.
                </p>
              </div>
            )}
          </div>

          {/* Dialog to display user profile */}
          <Dialog
            open={isOpen}
            onClose={closeUserProfile}
            fullScreen
          >
            <div className="flex overflow-y-auto hide-scrollbar inset-0  items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white relative"> {/* Add relative positioning */}
                {/* White background row */}
          

          <div className="grid grid-cols-3 items-center px-4 pt-3">
  <button
    type="button"
    onClick={closeUserProfile}
    aria-label="Go back"
    className="flex h-9 w-9 items-center justify-center rounded-full text-[#252424] transition hover:bg-gray-100 active:scale-95 dark:text-white dark:hover:bg-white/10"
  >
    <FaArrowLeft className="text-lg" />
  </button>

  <img src={logo} alt="logo" className="mx-auto h-7 w-auto object-contain" />

  <div /> 
</div>
              
                <DialogContent>
                  {selectedUser && (
                    <div>
                      <UserProfile selectedUserId={selectedUserId} />
                    </div>
                  )}
                </DialogContent>
              </div>
            </div>
          </Dialog>



        </div>
)}
      </div>
      {/* <footer className="w-full fixed bottom-0 left-0 backdrop-blur-md bg-white/30 border-t border-white/40">
        <div className="flex justify-center mb-2 mt-2.5">
          <button
            className="bg-blue-600 text-white px-4 py-1 rounded-md shadow-md hover:bg-blue-700 transition-colors focus:ring-2 focus:ring-blue-400 focus:ring-offset-1 focus:outline-none"
            onClick={handleEventPhotosClick}
          >
            Event Photos
          </button>
        </div>
      </footer> */}

      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: {
            width: drawerWidth,
          },
        }}
      >
        <div className="sticky top-0 z-10 h-12 flex items-center justify-between px-4 border-b border-gray-200 bg-white">
  <h2 className="text-base font-semibold text-gray-800">Event photos</h2>
  <IconButton onClick={() => setDrawerOpen(false)} aria-label="Close">
    <IoClose size={24} />
  </IconButton>
</div>

        <div style={{ padding: 20 }}>
          <Gallery isChild={true} />

          {/* <Button onClick={() => setDrawerOpen(false)} color="error">
            Close
          </Button> */}
        </div>
      </Drawer>
      {/* <Sheet isOpen={isDrawerOpen} onClose={() => setDrawerOpen(false)} snapPoints={[1]} initialSnap={0}>
        <Sheet.Container
          className="transition-all duration-300"
          style={{
            width: window.innerWidth < 768 ? '100%' : '50%',
            height: '100%',
            position: 'fixed',
            right: 0,
            left: 'auto',
            borderTopLeftRadius: '1rem',
            borderBottomLeftRadius: '1rem',
          }}
        >
          <Sheet.Header />
          <Sheet.Content className="p-4">
            <Gallery />
            <button
              className="text-black-600 outline"
              onClick={() => setDrawerOpen(false)}
            >
              Close
            </button>
          </Sheet.Content>
        </Sheet.Container>

        <Sheet.Backdrop onTap={() => setDrawerOpen(false)} />
      </Sheet> */}
    </>
  );
}